import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getAfcFilters } from "../../common/endpoints";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchAfcFilters = createApi(
  getAfcFilters,
  "POST"
);

const afcFiltersSlice = createSlice({
  name: "getAfcFilters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAfcFilters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAfcFilters.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAfcFilters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default afcFiltersSlice.reducer;